import * as actions from './fabricPriceSlab/actions'
import * as mutations from './fabricPriceSlab/mutations'
import * as getters from './fabricPriceSlab/getters'

import { dataProps } from './fabricPriceSlab/properties'

const state = {
    list: [],
    props: JSON.parse(JSON.stringify(dataProps)),
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/fabricPriceSlab.js